import React from 'react';
import {lang} from 'js/Core/lang';


const ShopName = (props) => {
	const txtLang = lang.txt;
	return (
		<p className="page-title"><span className="in02"><span> {props.shopName.name}</span> {txtLang.label_header_shopname}</span> </p>
	)
}


export default ShopName
